import script from "./VFeedStory.vue?vue&type=script&setup=true&lang=ts"
export * from "./VFeedStory.vue?vue&type=script&setup=true&lang=ts"

import "./VFeedStory.vue?vue&type=style&index=0&id=12bf44fd&lang=scss"

const __exports__ = script;

export default __exports__